import React from 'react';
import classes from './TabMenuLabelsContainer.module.css';
import { Heading } from '../../Heading';
import { Label } from '../../../api/queries';
import { Button } from '../../Button';
import { TabMenuLabelItem } from '../TabMenuLabelItem/TabMenuLabelItem';
import type { UseQueryResult } from '@tanstack/react-query';
import { Paragraph } from '../../Paragraph';
import { Alert } from '../../Alert/Alert';
import { LabelItem } from '../../LabelItem/LabelItem';

type TabMenuLabelsContainerProps = {
  expanded: boolean;
  labels: Array<Label>;
  selectedLabels: Array<Label>;
  setSelectedLabels: React.Dispatch<React.SetStateAction<Array<Label>>>;
  error: UseQueryResult['error'];
};

export const TabMenuLabelsContainer = ({
  expanded,
  labels,
  setSelectedLabels,
  selectedLabels,
  error,
}: TabMenuLabelsContainerProps) => {
  return (
    <div
      className={classes.labelsContainer}
      aria-expanded={expanded}
      role="list"
    >
      <div className={classes.labelsHeading}>
        <Heading as="h5" className={classes.labelsHeadingText}>
          Kategoriser artikler
        </Heading>
      </div>

      <div className={classes.labels}>
        {error ? (
          <div className={classes.labelsError}>
            <Alert
              title={'Feil ved henting av kategorier'}
              variant="danger"
              size="sm"
              headingSize="h4"
              style={{ marginBottom: 0 }}
            >
              <Heading as="h5">{error.name}</Heading>
              <Paragraph size="md">{error.message}</Paragraph>
            </Alert>
          </div>
        ) : (
          labels.map((label) => {
            const isActiveLabel: boolean = selectedLabels.some(
              (selectedLabel) => selectedLabel.id === label.id,
            );
            return (
              <LabelItem
                label={label}
                activeLabel={isActiveLabel}
                setSelectedLabels={setSelectedLabels}
                key={label.id}
              />
            );
          })
        )}
      </div>

      {/* <Button variant="neutral" className={classes.editButton}>
        Rediger kategorier
      </Button> */}
    </div>
  );
};
